import type { AnatomyBinding, AnatomyVariant } from "./componentAnatomy";

// Mined from the field-state mixin blocks in TagsInput.module.scss. Invalid
// is a variant, like Input's primary-invalid, so its hover stays reachable.

const border = (token: `--${string}`): AnatomyBinding => ({
    partId: "border",
    property: "border-color",
    token,
    via: "--tags-input-border",
});
const text = (token: `--${string}`): AnatomyBinding => ({
    partId: "label",
    property: "color",
    token,
    via: "--tags-input-fg",
});
const placeholder = (token: `--${string}`): AnatomyBinding => ({
    partId: "label",
    property: "color (placeholder)",
    token,
    via: "--tags-input-placeholder",
});

const focusBindings: readonly AnatomyBinding[] = [
    border("--border-accent-focus"),
    {
        partId: "focusRing",
        property: "box-shadow (spread)",
        token: "--border-width-thick",
    },
    {
        partId: "focusRing",
        property: "box-shadow (color)",
        token: "--focus-ring-color",
    },
];

const background: AnatomyBinding = {
    partId: "background",
    property: "background-color",
    token: "--bg-primary",
    via: "--tags-input-bg",
};

const restingBindings: readonly AnatomyBinding[] = [
    background,
    text("--fg-primary"),
    placeholder("--fg-tertiary"),
    border("--border-default"),
];

export const tagsInputVariantSpecs: readonly AnatomyVariant[] = [
    {
        id: "default",
        label: "Default",
        selector: "",
        restingBindings,
        stateBindings: {
            hover: [border("--border-hover")],
            focus: focusBindings,
        },
    },
    {
        id: "invalid",
        label: "Invalid",
        selector:
            ':has(.control[aria-invalid="true"]):not(:has(.control:disabled)):not([data-disabled]):not(:focus-within):not([data-forced-state="focus"])',
        restingBindings: [
            background,
            text("--fg-error"),
            placeholder("--fg-error-placeholder"),
            border("--border-error"),
        ],
        stateBindings: {
            hover: [border("--border-error-hover")],
            focus: [...restingBindings, ...focusBindings],
        },
    },
];
